import AnimationClip from '../AnimationClip';
import Rope from 'Prototype/Rope';
import RopeComponent from 'Component/Render/Rope';
import { AwaitIterators } from '../AnimationHelper';

interface IMeta {
}

export class RopeOnCardFlip extends AnimationClip<IMeta> {
    public* execute(
        rope: Rope,
        meta: IMeta,
    ): IterableIterator<number> {
        const ropeComponent = rope.getComponent(RopeComponent);
        const nodes = ropeComponent.getNodes();
        const { startNode, endNode } = ropeComponent;

        const tweens = nodes.map((node, i) => {
            const targetX = startNode.x + (endNode.x - startNode.x) / (nodes.length - 1) * i;
            const targetY = startNode.y + (endNode.y - startNode.y) / (nodes.length - 1) * i;

            return this
                .getTween(node)
                .to({
                    x: targetX,
                    y: targetY,
                }, 300);
        });

        yield* AwaitIterators(tweens.map((tween) => this.startTween(tween)));
    }
}
